import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./SharedListings.css";
import PropertyThumbnail from "./PropertyThumbnail";
import { get_properties } from "./lib/get-properties";
import { PropertyList } from "./lib/get-properties";
import { PropertySource } from "./lib/source";

interface Props {
  share_id: number;
}

function SharedListings(props: Props) {
  const [properties,setProperties] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [errorMessage,setErrorMessage] = React.useState<string|null>(null);
  const [source, setSource] = React.useState<PropertySource>('onekey');

  React.useEffect(() => {
    (async () => {
      setLoading(true);
      const resp : PropertyList = await get_properties(props.share_id);
      if(resp.properties.length === 0){
        setErrorMessage('Something is wrong. The link in question doesn\'t seem to exist');
        setProperties([]);
        return;
      }
      setErrorMessage(null);
      setProperties(resp.properties);
      setSource(resp.source ?? 'onekey');
      setLoading(false);
    })();
  }, []);
  return (
    <div className="App container SharedListings">
      <div className="content-area container col-md-12 border-1" id="overview">
        <div>
          <div className="row">
            {loading && (
              <div className="listings-loading-section">Loading...</div>
            )}
            {!loading && errorMessage !== null && (
              <b className="error">{errorMessage}</b>
            )}
            {!loading &&
                properties.map((value: string) => (
                  <div className="thumbnail-wrapper col-md-4 col-sm-6 col-lg-3 col-12">
                    <PropertyThumbnail
                      property_id={value}
                      sort_mode={"highest-first"}
                      display_mode={"property"}
                      remove_from_url={['share','viewMode']}
                      show_share_property_icons={false}
                      source={source}
                    />
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SharedListings;
